import { useSession } from '@/context/SessionProvider'

export const useSecurityApi = () => {
  const { sign, signIn } = useSession()

  return {
    apiRequest: async (url: string, payload: {}) => {
      const account = useSession.getState().account;
      if (!account) {
        signIn()
        return null
      }

      const data = JSON.stringify({
        ...payload,
        user: account.injectiveAddress,
        address: account.privateKey.toBech32(),
      })

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          signature: await sign(data),
        },
        body: data,
      })
        .then((res) => res.json())
        .catch((_err) => null)

      return response
    },
  }
}
